// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"4d25f375","453":"5d9d47fd"}[chunkId] + ".chunk.js";
};